import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Context } from "../Provider";
import { fetchApprovalProcessHistory } from "../service";
import { formatDateString } from "../../../utils";
import { theme } from "../../../theme";

const TimelineBlock = ({ data }) => {
    const step = data.ftm_approval_process_step;
    const admin = data.admin_user;

    return (
        <div className="timeline-block mb-3">
            <span
                className="timeline-step p-3"
                style={{ backgroundColor: step.ftm_approval_process_step_color }}
            >
                <i className="material-icons text-white text-sm opacity-10">
                    {step.ftm_approval_process_step_icon}
                </i>
            </span>
            <div className="timeline-content pt-1">
                <h6 className="text-dark text-sm font-weight-bold mb-0">
                    {step.ftm_approval_process_step_name}
                </h6>
                <p className="text-secondary text-xs mt-1 mb-0">
                    {formatDateString(data.ftm_approval_process_time)}
                </p>
                <p className="text-sm text-dark mt-3 mb-2">
                    {step.ftm_approval_process_step_message}
                </p>
                <p className="text-xs text-secondary mb-0">
                    Action by: <strong>{admin.admin_full_name}</strong> ({admin.role.role_name})
                </p>
            </div>
        </div>
    );
};

const NavCardAndHistory = () => {
    const { ftm_id } = useParams();
    const { approvalProcessSteps } = useContext(Context);

    const [loading, setLoading] = useState(true);
    const [history, setHistory] = useState(null);

    useEffect(() => {
        const getApprovalProcessHistory = async () => {
            try {
                setLoading(true);
                const response = await fetchApprovalProcessHistory(ftm_id);
                if (response.status === "Success") {
                    setHistory(response?.data);
                }
            } catch (error) {
                console.log("🚀 ~ getApprovalProcessHistory ~ error:", error);
            } finally {
                setLoading(false);
            }
        };

        getApprovalProcessHistory();
    }, [ftm_id]);

    return (
        <div className="col-lg-3">
            <div className="card position-sticky top-1">
                <ul className="nav flex-column bg-white border-radius-lg p-3">
                    {approvalProcessSteps.map((step, index) => {
                        // Check if this step exists in history
                        const hasHistory = history?.approval_process?.some(
                            (item) => item.ftm_approval_process_step.ftm_approval_process_step_id === step.ftm_approval_process_step_id
                        );

                        return (
                            <li className="nav-item" key={index}>
                                <a
                                    className={`nav-link d-flex text-dark`}
                                    href={`#${step.ftm_approval_process_step_key}`}
                                >
                                    <i
                                        className="material-icons text-lg me-2"
                                        style={{ color: step.ftm_approval_process_step_color }}
                                    >
                                        {step.ftm_approval_process_step_icon}
                                    </i>
                                    <span className="text-sm">{step.ftm_approval_process_step_name}</span>

                                    {/* ✅ Extra icon if step has history */}
                                    {hasHistory && (
                                        <i className={`material-icons text-sm ms-auto text-${theme.main}`}>verified</i>
                                    )}
                                </a>
                            </li>
                        );
                    })}
                </ul>

                {!loading && history?.approval_process.length > 0 && (     
                    <div className="card">
                        <div className="card-header pb-0">
                            <h6>History</h6>
                        </div>
                        <div className="card-body p-3">
                            <div className="timeline timeline-one-side" data-timeline-axis-style="dotted" style={{ height: "500px", overflow: "auto" }}>
                                {!loading && history?.approval_process?.map((item, index) => (
                                    <TimelineBlock key={index} data={item} />
                                ))}
                            </div>
                        </div>
                    </div>
                )}  
            </div>
        </div>
    );
};

export default NavCardAndHistory;